import { PauseCircle, ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { useAuth } from "@/auth/use-auth";
import { useShopSwitches } from "@/features/settings/shopSwitches";

/**
 * T13-41 bars under the header (live, R21 — they disappear by themselves once fixed):
 * - no 古物商許可 saved → 買取 / 委託受付 are closed (for the people who buy / take cards in, and
 *   whoever can fix it in Settings → Shop details);
 * - web orders paused → a reminder that the website is not taking orders.
 */
export function ShopSwitchBanners() {
  const { t } = useTranslation();
  const { can } = useAuth();
  const { secondhandLicensed, webOrdersPaused } = useShopSwitches();
  const concernsLicence =
    can("buylist.accept") ||
    can("consignment.intake") ||
    can("consignment.manage") ||
    can("settings.write");
  return (
    <>
      {secondhandLicensed === false && concernsLicence ? (
        <div
          role="status"
          data-slot="licence-banner"
          className="flex flex-wrap items-center gap-2 border-b border-[#b45309] bg-[#fef3c7] px-4 py-2 text-sm font-medium text-[#78350f]"
        >
          <ShieldAlert className="size-4 shrink-0" aria-hidden />
          <span>{t("shop_switches.licence_missing")}</span>
          {can("settings.read") ? (
            <Link className="underline underline-offset-2" to="/settings/store">
              {t("shop_switches.licence_fix")}
            </Link>
          ) : null}
        </div>
      ) : null}
      {webOrdersPaused === true ? (
        <div
          role="status"
          data-slot="web-orders-paused-banner"
          className="flex flex-wrap items-center gap-2 border-b border-[#b91c1c] bg-[#fee2e2] px-4 py-2 text-sm font-medium text-[#7f1d1d]"
        >
          <PauseCircle className="size-4 shrink-0" aria-hidden />
          <span>{t("shop_switches.web_orders_paused")}</span>
          {can("settings.read") ? (
            <Link className="underline underline-offset-2" to="/settings/checkout">
              {t("shop_switches.web_orders_open")}
            </Link>
          ) : null}
        </div>
      ) : null}
    </>
  );
}
